export const ADD_SOFTWARE_VERSION = 'add_software_version'
export const ADD_SOFTWARE_VERSION_SUCCESSFUL = 'add_software_version_successful'
export const ADD_SOFTWARE_VERSION_FAILED = 'add_software_version_failed'
